// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slideButton":"slide-button_slideButton__owLrX","next":"slide-button_next__6reHp","prev":"slide-button_prev__abt8l"};